import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getTransportationCompanyList as _getTransportationCompanyList, getTransportationCompanySupportList as _getTransportationCompanySupportList, addTransportationCompany, updateTransportationCompanyShowName, getTransportationCompanyDetail, updateTransportationCompany } from '@/services/systemsetting';
export default {
  name: 'transportCompany',
  components: {},
  i18n: require('./../i18n-basucSettings'),
  data: function data() {
    return {
      transportCompanySupportList: [],
      //系统支持的运输公司
      dataList: [],
      //商家运输公司列表数据
      isTableLoading: false,
      dialogStatus: '',
      //新建/修改状态位
      defaultLangObj: {},
      //默认语言对象
      languageList: [],
      //多语言list
      textMap: {
        //新建/修改title
        create: this.$t('basicSettings.newtransportCompany'),
        update: this.$t('basicSettings.edittransportCompany')
      },
      visible: false,
      //新建/修改 显示
      visiblePC: false,
      //参数配置弹窗显示状态
      datavalue: {
        //新建/修改 字段
        transportCompany: undefined,
        nameList: [],
        appid: '',
        appsecret: '',
        url: ''
      },
      parameterConfigurationData: {
        appid: "",
        appsecret: ""
      },
      initData: {},
      rules: {
        transportCompany: [{
          required: true,
          message: this.$t('transPort.rule1'),
          trigger: 'change'
        }]
      },
      transportDis: false,
      rowID: null,
      addTransportationCompanyLoading: false,
      updateTransportationCompanyShowNameLoading: false
    };
  },
  mounted: function mounted() {
    var self = this;
    self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.getTransportationCompanyList();
  },
  methods: {
    //获取运输公司列表
    getTransportationCompanyList: function getTransportationCompanyList() {
      var self = this;
      _getTransportationCompanyList().then(function (res) {
        if (res.data.code == 200) {
          self.dataList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
    },
    //获取系统支持的运输公司列表，新建下拉选择使用
    getTransportationCompanySupportList: function getTransportationCompanySupportList() {
      var self = this;
      self.isTableLoading = true;
      _getTransportationCompanySupportList().then(function (res) {
        if (res.data.code == 200) {
          self.transportCompanySupportList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 参数配置 */
    // configuration(reword) {
    // 	let self = this;
    // 	self.visiblePC = true;
    // },
    edit: function edit(record) {
      var _this = this;
      var self = this;
      this.rowID = record.id;
      this.getTransportationCompanySupportList();
      this.transportDis = true;
      this.resetdatavalue();
      var index = self.datavalue.nameList.findIndex(function (item) {
        return item.langId = self.defaultLangObj.langId;
      });
      self.datavalue.transportCompany = record.name;
      self.datavalue.nameList[index].name = record.showName;
      // 获取详情
      getTransportationCompanyDetail(record.id).then(function (res) {
        if (res.data.code == 200) {
          // 将对应多语言名称赋值
          self.datavalue.nameList = self.datavalue.nameList.map(function (item) {
            var newobj = res.data.data.list.filter(function (item2) {
              return item2.langId == item.langId;
            });
            return Object.assign(item, newobj[0]);
          });
          self.datavalue.appid = res.data.data.appid;
          self.datavalue.appsecret = res.data.data.appsecret;
          self.datavalue.transportCompany = res.data.data.systemTransportationId;
          self.datavalue.url = res.data.data.queryUrl;
        }
      });
      this.dialogStatus = 'update';
      this.$nextTick(function () {
        _this.visible = true;
      });
    },
    /* 添加按钮 */add: function add() {
      var _this2 = this;
      this.getTransportationCompanySupportList();
      this.dialogStatus = 'create';
      this.transportDis = false;
      this.resetdatavalue();
      this.$nextTick(function () {
        _this2.visible = true;
      });
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      // this.visiblePC = false;
    },
    getParams: function getParams() {
      var newList = this.datavalue.nameList.filter(function (item) {
        var obj = {
          langId: item.langId,
          name: item.name
        };
        if (item.id) {
          return _objectSpread(_objectSpread({}, obj), {}, {
            id: item.id
          });
        } else if (item.name) {
          return _objectSpread(_objectSpread({}, obj), {}, {
            id: null
          });
        }
      });
      var params = {
        systemTransportationId: this.datavalue.transportCompany,
        transportationAppid: this.datavalue.appid,
        transportationAppsecret: this.datavalue.appsecret,
        queryUrl: this.datavalue.url,
        list: newList
      };
      return params;
    },
    /* 初始化输入项 */resetdatavalue: function resetdatavalue() {
      var _this3 = this;
      var self = this;
      var nameList = [];
      self.languageList.forEach(function (item) {
        var nameDetail = {};
        nameDetail.langId = item.langId;
        nameDetail.languageName = _this3.$t('transPort.name') + "(" + item.langName + ')';
        nameDetail.name = "";
        nameList.push(nameDetail);
      });
      self.initData.nameList = nameList;
      self.initData.transportCompany = undefined;
      self.initData.appid = '';
      self.initData.appsecret = '';
      self.initData.url = '';
      self.datavalue = _.cloneDeep(self.initData);
    },
    /* 参数设置确认事件 */updatePC: function updatePC() {
      var _this4 = this;
      var self = this;
      self.$refs.parameterConfigurationDataForm.validate(function (valid) {
        if (valid) {
          self.visiblePC = false;
          _this4.$message.success(_this4.$t('public.addSuccessfully'));
          // addData(self.datavalue).then((res) => {
          // 	if (res.code == 200) {
          // 		self.$notification.info({
          // 			message: res.message
          // 		})
          // 		self.getTransportationCompanyList()
          // 		self.resetFormDate()
          // 	} else {
          // 		self.$notification.error({
          // 			message: res.message
          // 		})
          // 	}
          // });
        }
      });
    },
    /* 新增编辑确定 */save: function save() {
      var _this5 = this;
      this.$refs.dataForm2.validate(function (valid) {
        if (valid) {
          var params = _this5.getParams();
          if (_this5.addTransportationCompanyLoading) return;
          _this5.addTransportationCompanyLoading = true;
          addTransportationCompany(params).then(function (res) {
            if (res.data.code == 200) {
              _this5.$message.success(_this5.$t('publicuse.addSuccess'));
              _this5.getTransportationCompanyList();
              _this5.resetFormDate();
              _this5.visible = false;
            }
          }).finally(function () {
            _this5.addTransportationCompanyLoading = false;
          });
        }
      });
    },
    /* 确定更新 */update: function update() {
      var _this6 = this;
      var self = this;
      self.$refs.dataForm2.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var params, res;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 5;
                  break;
                }
                params = _this6.getParams();
                params.id = _this6.rowID;
                if (!_this6.updateTransportationCompanyShowNameLoading) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                _this6.updateTransportationCompanyShowNameLoading = true;
                _context.p = 2;
                _context.n = 3;
                return updateTransportationCompanyShowName(params);
              case 3:
                res = _context.v;
                if (res.data.code == 200) {
                  self.visible = false;
                  _this6.$message.success(_this6.$t('public.updateSuccessfully'));
                  _this6.getTransportationCompanyList();
                }
              case 4:
                _context.p = 4;
                _this6.updateTransportationCompanyShowNameLoading = false;
                return _context.f(4);
              case 5:
                return _context.a(2);
            }
          }, _callee, null, [[2,, 4, 5]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    changeInput: function changeInput(e) {
      this.$forceUpdate();
    },
    // 修改运输公司的状态
    confirm: function confirm(row, type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var transportationStatus, key, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              transportationStatus = type == 'delete' ? '1' : String(2 - row.transportationStatus);
              key = "updateTransportationCompanyLoading".concat(row.id).concat(type);
              if (!row[key]) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              row[key] = true;
              _context2.p = 2;
              _context2.n = 3;
              return updateTransportationCompany(String(row.id), transportationStatus);
            case 3:
              res = _context2.v;
              if (res.data.code == 200) {
                _this7.$message.success(_this7.$t('public.updateSuccessfully'));
                _this7.getTransportationCompanyList();
                _this7.visible = false;
              }
            case 4:
              _context2.p = 4;
              row[key] = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2,, 4, 5]]);
      }))();
    },
    cancel: function cancel() {
      // this.$message.error(this.$t('switchError'));
    }
  }
};